import { Link } from 'react-router';
import type { ListedDue } from '@tahi/core';
import { Money } from '../../../ui';
import { cn } from '../../../ui/cn';
import { spokenPeso } from '../../../ui/spokenPeso';
import { FOCUS } from '../../spending/styles';
import { copy } from '../copy';
import { dayShort, partialText, whenText } from '../format';
import { PAYMENTS_BASE } from '../hooks';

export function payPath(payeeId: string, period: string): string {
  return `${PAYMENTS_BASE}/p/${payeeId}/due/${period}`;
}

/** One line of "Payments due": name, when, what's left to pay. Opens the pay sheet. */
export function DueRow({ due }: { due: ListedDue }) {
  const late = due.flag === 'late';
  const sub = [
    whenText(due.daysAway),
    dayShort(due.dueDate),
    due.status === 'partial' ? partialText(due) : null,
    due.estimated ? copy.estimated : null,
    due.transfer ? 'card' : null,
  ]
    .filter(Boolean)
    .join(' · ');
  return (
    <li>
      <Link
        to={payPath(due.payeeId, due.period)}
        aria-label={`${due.payeeName}, ${spokenPeso(due.remainingMinor)}, ${sub}`}
        className={cn(
          'flex min-h-14 items-center justify-between gap-3 rounded-2xl px-2 py-2 hover:bg-secondary',
          FOCUS,
        )}
      >
        <span className="flex min-w-0 flex-col">
          <span className="truncate text-fg">{due.payeeName}</span>
          <span className={cn('text-sm', late ? 'text-destructive' : 'text-muted')}>{sub}</span>
        </span>
        <Money
          minor={due.remainingMinor}
          cents="auto"
          animate={false}
          className={cn('shrink-0 text-base', late ? 'text-destructive' : 'text-fg')}
        />
      </Link>
    </li>
  );
}
